import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import parts from '../../utils/constants/parts'

const quantityRange = parts.map((part) => part.quantity)

export const initialState = {
    priceFrom: 0,
    priceTo: 0,
    isInStock: false,
    isOfDealer: false,
    delivery: 'any',
    quantityFrom: Math.min(...quantityRange),
    quantityTo: Math.max(...quantityRange),
    brand: []
}

export const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setPriceFrom: (state, action) => {
            state.priceFrom = action.payload
        },
        resetPriceFrom: (state) => {
            state.priceFrom = initialState.priceFrom
        },
        setPriceTo: (state, action) => {
            state.priceTo = action.payload
        },
        resetPriceTo: (state) => {
            state.priceTo = initialState.priceTo
        },
        setIsInStock: (state, action) => {
            state.isInStock = action.payload
        },
        resetIsInStock: (state) => {
            state.isInStock = initialState.isInStock
        },
        setIsOfDealer: (state, action) => {
            state.isOfDealer = action.payload
        },
        resetIsOfDealer: (state) => {
            state.IsOfDealer = initialState.IsOfDealer
        },
        setDelivery: (state, action) => {
            state.delivery = action.payload
        },
        resetDelivery: (state) => {
            state.delivery = initialState.delivery
        },
        setQuantityFrom: (state, action) => {
            state.quantityFrom = action.payload
        },
        resetQuantityFrom: (state) => {
            state.quantityFrom = initialState.quantityFrom
        },
        setQuantityTo: (state, action) => {
            state.quantityTo = action.payload
        },
        resetQuantityTo: (state) => {
            state.quantityTo = initialState.quantityTo
        },
        setBrand: (state, action) => {
            state.brand = action.payload
        },
        resetBrand: (state) => {
            state.brand = initialState.brand
        },
        resetAll: () => initialState
    }
})

export const {
    setPriceFrom,
    resetPriceFrom,
    setPriceTo,
    resetPriceTo,
    setIsInStock,
    resetIsInStock,
    setIsOfDealer,
    resetIsOfDealer,
    setDelivery,
    resetDelivery,
    setQuantityFrom,
    resetQuantityFrom,
    setQuantityTo,
    resetQuantityTo,
    setBrand,
    resetBrand,
    resetAll
} = filterSlice.actions

export const selectPriceFrom = (state) => state.filter.priceFrom
export const selectPriceTo = (state) => state.filter.priceTo
export const selectIsInStock = (state) => state.filter.isInStock
export const selectIsOfDealer = (state) => state.filter.isOfDealer
export const selectDelivery = (state) => state.filter.delivery
export const selectQuantityFrom = (state) => state.filter.quantityFrom
export const selectQuantityTo = (state) => state.filter.quantityTo
export const selectBrand = (state) => state.filter.brand
export const selectFilter = (state) => state.filter
export const selectIsFilterApplied = (state) => !_.isEqual(state.filter, initialState)

export const selectInitialPriceFrom = (state) => initialState.priceFrom
export const selectInitialPriceTo = (state) => initialState.priceTo
export const selectInitialIsInStock = (state) => initialState.isInStock
export const selectInitialIsOfDealer = (state) => initialState.isOfDealer
export const selectInitialDelivery = (state) => initialState.delivery
export const selectInitialQuantityFrom = (state) => initialState.quantityFrom
export const selectInitialQuantityTo = (state) => initialState.quantityTo
export const selectInitialBrand = (state) => initialState.brand

export default filterSlice.reducer
